import { isNftCapitalDisposalClass } from "../../shared/taxExportEligibility.js";

export function shouldIncludeNftDisposalExportRow(
  row = {},
  { isUK = false } = {}
) {
  const cls = String(row.classification || row.type || "")
    .trim()
    .toLowerCase();
  if (isUK) {
    return cls === "sale_payment" || cls === "nft_transform_disposal";
  }
  return isNftCapitalDisposalClass(cls);
}

export function collectNftTaxableFifoLegs(rows = []) {
  const out = [];
  for (const row of Array.isArray(rows) ? rows : []) {
    if (!shouldIncludeNftDisposalExportRow(row)) continue;
    if (!Array.isArray(row.fifoLegs)) continue;
    row.fifoLegs.forEach((leg, index) => {
      if (leg?.isTaxable === true) out.push({ row, leg, index });
    });
  }
  return out;
}
